<template>
  <div class="px-3"  v-resize="onResize">
    <h1 class="py-6">{{ $t("viewGoods.title") }}</h1>
    <v-row class="mx-0 w-100 mb-5">
      <v-col xs="6" md="4" class="pa-0 mx-0">
        <v-card class="pa-3 ma-0" elevation="0">
          <v-text-field
            outlined
            :placeholder="$t('viewGoods.search_placeholder')"
            append-icon="fa-times"
            hide-details
            @click:append="search = ''"
            v-model="search"
          ></v-text-field>
        </v-card>
      </v-col>
      <v-col xs="3" class="pa-0 mx-0 ml-1">
        <v-card class="pa-3 ma-0" elevation="0">

          <v-select
            :disabled="!fetched"
            :readonly="!fetched"
            v-model="selectedStoragesList"
            :item-disabled="()=>!fetched"
            :items="storages"
            hide-details
            chips
            :label="$t('common.storages')"
            multiple
            outlined
            height="30"
            item-text="name"
            item-value="id"
            return-object
          >
            <template v-slot:prepend-item>
              <v-list-item
                :disabled="!fetched"
                ripple
                @mousedown.prevent
                @click="toggleSelectedStorages"
              >
                <v-list-item-action>
                  <v-icon
                    :disabled="!fetched"
                    :color="
                      selectedStoragesList.length > 0 ? 'indigo darken-4' : ''
                    "
                  >
                    {{ selectedStoragesListIcon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("common.select_all") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0 && selectedAllStorages">
                <span>{{ $t("common.all") }}</span>
              </v-chip>
              <v-chip v-if="index === 0 && !selectedAllStorages">
                <span>{{ item.name }}</span>
              </v-chip>
              <span
                v-if="index === 1 && !selectedAllStorages"
                class="grey--text text-caption"
              >
                (+{{ selectedStoragesList.length - 1 }} )
              </span>
            </template>
          </v-select>
        </v-card>
      </v-col>
      <v-col xs="3">
        <v-btn
          min-height="48"
          class="mb-0 white--text ml-3 green-shadow float-right mr-1"
          @click="
            goodsAddForm.visible = !goodsAddForm.visible;
            clearOneGoods();
            focusToFirst();
            $refs.goodsForm.resetValidation();
          "
          color="success"
          :title="$t('common.add')"
        >
          {{ $t("common.add") }}
        </v-btn>
        <v-btn
          min-width="48"
          min-height="48"
          class="mb-0 white--text ml-3 px-0 green-shadow float-right"
          to="/storage/import/"
          :title="$t('viewImportToStorage.title')"
          color="success"
        >
          <v-icon>$upload</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-form ref="goodsForm" v-model="goodsAddForm.formValid">
      <v-data-table
          ref="goodsTable"
        :loading="!fetched"
        :headers="goodsTableHeader.filter((item)=>{
          return (!item.only_lang) || (item.only_lang && item.only_lang === this.lang)
        })"
        :height="tableHeight"
        :items="filtedredGoods"
        class="elevation-0 mb-3 small-padding-td-wrap"
        :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          15, 30, 50,
          //-1
        ],
      }"
        @update:options="setTableOptions"
        :server-items-length="goodsTotal"
        :options="tableOptions"
      >
        <template v-slot:footer.page-text="props">
          {{
            $t("tables.x_of_y", [
              `${props.pageStart}-${props.pageStop}`,
              props.itemsLength,
            ])
          }}
        </template>
        <template v-slot:header.avito_export_price="props">
          <v-icon class="mr-2">$avito</v-icon>{{props.header.text}}
        </template>
        <template v-slot:header.zzap_export_price="props">
          <v-icon class="mr-2">$zzap</v-icon>{{props.header.text}}
        </template>
        <template v-slot:header.ozon_export_price="props">
          <v-icon class="mr-2">$ozon</v-icon>{{props.header.text}}
        </template>
        <template v-slot:body.prepend="props">
          <tr v-if="goodsAddForm.visible" >
            <td class="text-no-wrap">
              <v-text-field
                ref="formBrandField"
                :rules="[
                  (v) => !!v || $t('form.validationErrors.field_is_required'),
                ]"
                v-model="oneGoods.nomenclature.brand"
                :label="$t('common.brand')"
                @keyup.enter.stop="saveOneGoods"
                @keyup.esc.stop="goodsAddForm.visible = false"
              ></v-text-field>
            </td>
            <td class="text-no-wrap">
              <v-text-field
                :rules="[
                  (v) => !!v || $t('form.validationErrors.field_is_required'),
                ]"
                v-model="oneGoods.nomenclature.part_code"
                :label="$t('common.part_code')"
                @keyup.enter.stop="saveOneGoods"
                @keyup.esc.stop="goodsAddForm.visible = false"
              ></v-text-field>
            </td>
            <td class="text-no-wrap">
              <v-text-field
                v-model="oneGoods.nomenclature.name"
                :label="$t('common.title')"
                @keyup.enter.stop="saveOneGoods"
                @keyup.esc.stop="goodsAddForm.visible = false"
              ></v-text-field>
            </td>
            <td class="text-no-wrap">
              <v-text-field
                :rules="[
                  (v) => !!v || $t('form.validationErrors.field_is_required'),
                ]"
                v-model="oneGoods.price"
                :label="$t('common.price')"
                @keyup.enter.stop="saveOneGoods"
                @keyup.esc.stop="goodsAddForm.visible = false"
              ></v-text-field>
            </td>
            <td class="text-no-wrap text-right">
              {{ oneGoods.price_with_margin }}
            </td>
            <td class="text-no-wrap" v-if="isVisibleRussianAdsPlatforms">
              <v-text-field
                prepend-inner-icon="$avito"
                v-model="oneGoods.avito_export_price"
                @keyup.enter.stop="saveOneGoods"
                @keyup.esc.stop="goodsAddForm.visible = false"
              ></v-text-field>
            </td>
            <td class="text-no-wrap" v-if="isVisibleRussianAdsPlatforms">
              <v-text-field
                prepend-inner-icon="$zzap"
                v-model="oneGoods.zzap_export_price"
                @keyup.enter.stop="saveOneGoods"
                @keyup.esc.stop="goodsAddForm.visible = false"
              ></v-text-field>
            </td>
            <td class="text-no-wrap" v-if="isVisibleRussianAdsPlatforms">
              <v-text-field
                prepend-inner-icon="$ozon"
                v-model="oneGoods.ozon_export_price"
                @keyup.enter.stop="saveOneGoods"
                @keyup.esc.stop="goodsAddForm.visible = false"
              ></v-text-field>
            </td>
            <td class="text-no-wrap">
              <v-text-field
                :rules="[
                  (v) => !!v || $t('form.validationErrors.field_is_required'),
                ]"
                v-model="oneGoods.amount"
                :label="$t('common.amount')"
                @keyup.enter.stop="saveOneGoods"
                @keyup.esc.stop="goodsAddForm.visible = false"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                v-if="oneGoods.storage && oneGoods.storage.id"
                v-model="oneGoods.min_amount"
                :label="$t('viewGoods.min_amount')"
                @keyup.enter.stop="saveOneGoods"
                @keyup.esc.stop="goodsAddForm.visible = false"
              ></v-text-field>
            </td>
            <td class="text-no-wrap">
              <v-select
                :rules="[
                  (v) => !!v || $t('form.validationErrors.field_is_required'),
                ]"
                :label="$t('viewGoods.storage')"
                :items="storages"
                item-text="name"
                return-object
                class="pointer"
                clearable
                v-model="oneGoods.storage"
                @keyup.enter.stop="saveOneGoods"
                @keyup.esc.stop="goodsAddForm.visible = false"
              ></v-select>
            </td>
            <td class="text-no-wrap">
              <v-select
                v-if="oneGoods.storage"
                :label="$t('viewGoods.storage_rack')"
                :items="storages.find((s) => s.id === oneGoods.storage.id).rack"
                item-text="name"
                return-object
                class="pointer"
                clearable
                v-model="oneGoods.rack"
                @keyup.enter.stop="saveOneGoods"
                @keyup.esc.stop="goodsAddForm.visible = false"
              ></v-select>
            </td>
            <td class="text-no-wrap">
              <v-select
                v-if="oneGoods.storage && oneGoods.rack && oneGoods.rack.shelf"
                :label="$t('viewGoods.storage_rack_shelve')"
                :items="
                  storages
                    .find((s) => s.id === oneGoods.storage.id)
                    .rack.find((r) => r.id === oneGoods.rack.id).shelf
                "
                item-text="name"
                return-object
                class="pointer"
                clearable
                v-model="oneGoods.shelf"
                @keyup.enter.stop="saveOneGoods"
                @keyup.esc.stop="goodsAddForm.visible = false"
              ></v-select>
            </td>
            <td class="text-no-wrap">
              <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                @click="goodsAddForm.visible = false"
                @keyup.enter.stop="goodsAddForm.visible = false"
                color="red lighten-2"
                class="mb-0 ml-3 px-0 white--text"
                :title="$t('common.cancel')"
              >
                <v-icon small>$cross</v-icon>
              </v-btn>
              <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                @click="saveOneGoods"
                @keyup.enter.stop="saveOneGoods"
                color="success"
                class="mb-0 ml-3 px-0 white--text"
                :title="$t('common.save')"
              >
                <v-icon small v-if="oneGoods.id">$save</v-icon>
                <v-icon small v-else>mdi-plus</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <template v-slot:item="props">
          <tr>
            <td class="text-no-wrap">
              <span class="dashed pointer" @click="showNomenclatureWindow(props.item.nomenclature)">
                {{ props.item.nomenclature.brand }}
              </span>
            </td>
            <td class="text-no-wrap">
              <span class="dashed pointer" @click="showNomenclatureWindow(props.item.nomenclature)">
                {{ props.item.nomenclature.part_code }}
              </span>
            </td>
            <td class="text-no-wrap">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <span
                      class="d-inline-block text-truncate"
                      style="max-width: 150px"
                    >
                      {{ props.item.nomenclature.name }}
                    </span>
                  </span>
                </template>
                <span>{{ props.item.nomenclature.name }}</span>
              </v-tooltip>
            </td>
            <td class="text-no-wrap text-right">{{ props.item.price }}</td>
            <td class="text-no-wrap text-right">
              {{ props.item.price_with_margin }}
            </td>
            <td class="text-no-wrap text-right" v-if="isVisibleRussianAdsPlatforms">
              <div v-if="props.item.avito_export_price">
                {{ props.item.avito_export_price }}
              </div>
            </td>
            <td class="text-no-wrap text-right" v-if="isVisibleRussianAdsPlatforms">
              <div v-if="props.item.zzap_export_price">
                {{ props.item.zzap_export_price }}
              </div>
            </td>
            <td class="text-no-wrap text-right" v-if="isVisibleRussianAdsPlatforms">
              <div v-if="props.item.ozon_export_price">
                {{ props.item.ozon_export_price }}
              </div>
            </td>
            <td class="text-no-wrap">
              {{ props.item.amount }}
              <span v-if="props.item.in_reserve > 0" class="indigo--text">
                /
                {{ props.item.in_reserve }}
              </span>
            </td>
            <td>
              <span v-if="props.item.min_amount">
                {{ props.item.min_amount }}

                <span
                  class="red--text"
                  v-if="props.item.sum_amount <= props.item.min_amount"
                >
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-icon x-small color="red"
                          >fa-exclamation-triangle</v-icon
                        >
                        {{ props.item.sum_amount }}
                      </span>
                    </template>
                    <span
                      >{{ $t("viewGoods.total_left") }}:
                      {{ props.item.sum_amount }}</span
                    >
                  </v-tooltip>
                </span>
              </span>
            </td>
            <td class="text-no-wrap">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <span
                        class="d-inline-block text-truncate"
                        style="max-width: 150px"
                    >
                      {{ props.item.storage ? props.item.storage.name : "" }}
                    </span>
                  </span>
                </template>
                <span>{{ props.item.storage ? props.item.storage.name : "" }}</span>
              </v-tooltip>
            </td>
            <td class="text-no-wrap">
              {{ props.item.rack ? props.item.rack.name : "" }}
            </td>
            <td class="text-no-wrap">
              {{ props.item.shelf ? props.item.shelf.name : "" }}
            </td>
            <td class="text-no-wrap text-right">
              <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                @click="removeOneGoods(props.item.id)"
                @keyup.enter.stop="removeOneGoods(props.item.id)"
                color="red lighten-2"
                class="mb-0 ml-3 px-0 white--text"
                :title="$t('common.remove')"
              >
                <v-icon small>$trash</v-icon>
              </v-btn>
              <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                color="primary"
                class="mb-0 ml-3 px-0 white--text"
                @click="editOneGoods(props.item.id)"
                @keyup.enter.stop="editOneGoods(props.item.id)"
                :title="$t('common.edit')"
              >
                <v-icon small>$pencil</v-icon>
              </v-btn>
              <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                color="primary"
                class="mb-0 ml-3 px-0 white--text"
                @click="showNomenclatureWindow(props.item.nomenclature)"
                @keyup.enter.stop="showNomenclatureWindow(props.item.nomenclature)"
                :title="$t('common.edit_nomenclature')"
              >
                <v-icon x-small>fa-edit</v-icon>
              </v-btn>
              <v-btn
                @click="printQRCode(props.item)"
                @keyup.enter.stop="showQRcodeWindow(props.item)"
                elevation="0"
                min-width="36"
                min-height="36"
                color="blue lighten-2"
                class="mb-0 ml-3 px-0 white--text"
              >
                <v-icon small>fa-qrcode</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          {{ $t("common.no_data_available") }}
        </template>
        <template v-slot:no-results>
          {{ $t("common.no_data_available") }}
        </template>
      </v-data-table>
    </v-form>
    <div class="d-none">
      <qrcode-vue
        id="qrCode"
        :value="qrCodeWindow.brand + ' ' + qrCodeWindow.part_code"
        :size="500"
        level="H"
      />
    </div>
    <nomenclature-form
        :id="nomenclatureWindow.id"
        :show="nomenclatureWindow.isVisible"
        :action="nomenclatureWindow.action"
        @hide="nomenclatureWindow.isVisible = false"
        @store="(items) => selectGoodsNomenclatureSearchItems(items)"
        @update="(data) => updateGoodsNomenclature(data)"
    />
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import QrcodeVue from "qrcode.vue";
import NomenclatureForm from "@/components/storage/NomenclatureForm";

export default {
  components: {NomenclatureForm, QrcodeVue },
  data: () => ({
    isMounted:false,
    nomenclatureWindow:{
      id:null,
      isVisible: false,
      action: null
    },
    getGoodsTimeoutId: null,
    selectedStoragesList: [],
    qrCodeWindow: {
      brand: null,
      part_code: null,
    },
    goodsAddForm: {
      visible: false,
      formValid: null,
    },
    tableHeight: "100",
  }),
  mounted() {
    this.getStorages().then(() => {
      this.fillStorages();
      this.getGoods();
    });
    this.isMounted = true;
  },
  watch: {
    search(to, from) {
      if (to.length >= 3 || to.length === 0) {
        clearTimeout(this.findTimeoutId);
        this.findTimeoutId = setTimeout(() => {
          this.getGoods();
        }, 1100);
      }
    },
    selectedStoragesList(to) {
      clearTimeout(this.getGoodsTimeoutId);
      this.getGoodsTimeoutId = setTimeout(() => {
        let storages = [];
        if (to.length === 0) {
          storages = [];
        } else {
          to.forEach((storage) => {
            storages.push(storage.id);
          });
        }
        if (storages.length === this.storages.length) {
          if (this.$route.query.storages) {
            this.$router.push({ path: "/storage" }).then(() => {
              this.$nextTick(() => {
                this.getGoods();
              });
            });
          }
        } else {
          if (this.$route.query.storages !== storages.join(",") + "") {
            this.$router
                .push({ path: "/storage", query: { storages: storages.join(",") } })
                .then(() => {
                  this.$nextTick(() => {
                    this.getGoods();
                  });
                });
          }
        }
      }, 1000);
    },
    fetched() {
      this.$nextTick(() => {
        this.setTableHeight();
      });
    },
  },
  methods: {
    onResize() {
      this.setTableHeight();
    },
    setTableHeight() {
      let rect = this.$refs["goodsTable"].$el.getBoundingClientRect();
      if (rect) {
        this.tableHeight = window.innerHeight - rect.top - 90;
      }
    },
    setTableOptions(options) {
      this.tableOptions = options;
      if(!this.isMounted) return;
      this.getGoods();
    },
    updateGoodsNomenclature(nomenclature){
      this.goods.forEach(item=>{
        if(parseInt(item.nomenclature_id)===parseInt(nomenclature.id)){
          item.nomenclature = nomenclature;
        }
      })
      this.goods = [...this.goods]
    },
    isDisabledStorageItemForSelect(){
      if(!this.fetched) return true;
    },
    getGoods() {
      this.$store.dispatch("goods/get", {
        storages: this.$route.query.storages
          ? this.$route.query.storages.split(",")
          : [],
      });
    },
    toggleSelectedStorages() {
      this.$nextTick(() => {
        if (this.selectedAllStorages) {
          this.selectedStoragesList = [];
        } else {
          this.selectedStoragesList = [];
          this.storages.forEach((storage) => {
            this.selectedStoragesList.push(storage);
          });
        }
      });
    },
    getStorages() {
      return this.$store.dispatch("storages/get");
    },
    fillStorages() {
      let storageIds = [];
      if (this.$route.query.storages) {
        storageIds = this.$route.query.storages.split(",");
      }
      let selectedAll = storageIds.length === 0;
      this.storages.forEach((storage) => {
        if (selectedAll || storageIds.includes(storage.id + "")) {
          this.selectedStoragesList.push(storage);
        }
      });
    },
    showNomenclatureWindow(nomenclature, action='update'){
      this.nomenclatureWindow.id = nomenclature.id;
      this.nomenclatureWindow.action=action;
      this.nomenclatureWindow.isVisible=true;
    },
    printQRCode(item) {
      this.qrCodeWindow.brand = item.nomenclature.brand;
      this.qrCodeWindow.part_code = item.nomenclature.part_code;
      this.$nextTick(() => {
        let title = item.nomenclature.brand + " " + item.nomenclature.part_code;
        let content = document.getElementById("qrCode");
        let dataUrl = content.firstChild.toDataURL();
        let windowContent = `<!DOCTYPE html>
      <html>
      <head><title>Print canvas</title></head>
      <body style="text-align: center;">
      <div style="background-image: url(${dataUrl}); width:80px;height:80px;background-position: center; background-size: cover;margin:0 auto;"></div>
      <div style="padding-top:5px;">${title}</div>
      </body>
      </html>`;
        let printWin = window.open("", "", "width=500,height=500");
        printWin.document.open();
        printWin.document.write(windowContent);
        printWin.document.close();
        printWin.focus();
        printWin.print();
        printWin.close();
      });
    },
    clearOneGoods() {
      for (let i in this.oneGoods) {
        if (i === "nomenclature") {
          for (let j in this.oneGoods[i]) {
            this.oneGoods[i][j] = null;
          }
        } else {
          this.oneGoods[i] = null;
        }
      }
    },
    removeOneGoods(id) {
      this.$store.dispatch(`goods/remove`, id).then((result) => {
        if (result) {
          this.getGoods();
        }
      });
    },
    editOneGoods(id) {
      if (this.$refs.goodsForm) this.$refs.goodsForm.resetValidation();
      this.$nextTick(function () {
        this.goodsAddForm.visible = true;
        this.focusToFirst();
        this.oneGoods = JSON.parse(
          JSON.stringify(this.goods.filter((item) => item.id === id)[0])
        );
      });
    },
    focusToFirst() {
      this.$nextTick(function () {
        this.$refs.formBrandField.focus();
      });
    },
    saveOneGoods() {
      let hide = false;
      if (!this.$refs.goodsForm.validate()) return;
      if (this.oneGoods.id) hide = true;

      this.$store
        .dispatch("goods/one_goods_save", this.oneGoods)
        .then((res) => {
          if (this.$refs.goodsForm && res)
            this.$refs.goodsForm.resetValidation();
          this.updateGoodsNomenclature(res.one_goods.nomenclature)
          if (this.$refs.goodsForm && res) {
            this.clearOneGoods();
            this.focusToFirst();
            if (hide) this.goodsAddForm.visible = false;
          }
        });
    },
  },
  computed: {
    isVisibleRussianAdsPlatforms(){
      return this.lang === 'ru';
    },
    ...mapFields("site", ["lang"]),
    ...mapFields("storages", ["storages"]),
    ...mapFields("customers", ["customers", "fetched"]),
    ...mapFields("goods", [
        "goods",
        "search",
        "goodsTotal",
        "tableOptions",
        "oneGoods",
        "fetched",
        "savingInProgress"
    ]),
    selectedStoragesListIcon() {
      if (this.selectedAllStorages) return "mdi-close-box";
      if (this.selectedStoragesList.length > 0) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    selectedAllStorages() {
      return this.storages.length === this.selectedStoragesList.length;
    },
    filtedredGoods() {
      return this.goods;
      return this.goods.filter((item) => {
        if (!this.search.length) return true;
        let needle = this.search.toUpperCase();
        let res =
          item.nomenclature.brand.toUpperCase().indexOf(needle) != -1 ||
          item.nomenclature.part_code.toUpperCase().indexOf(needle) != -1 ||
          item.nomenclature.name.toUpperCase().indexOf(needle) != -1;
        return res;
      });
    },
    goodsTableHeader() {
      return [
        {
          text: this.$t("common.brand"),
          value: "nomenclature.brand",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.part_code"),
          value: "part_code",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.title"),
          value: "name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.price"),
          value: "price",
          sortable: true,
          class: "text-no-wrap",
          align: "end"
        },
        {
          text: this.$t("common.price_with_margin"),
          value: "price_with_margin",
          sortable: false,
          class: "text-no-wrap",
          align: "end"
        },
        {
          text: this.$t("viewSettings.goods_export.price_for_avito"),
          value: "avito_export_price",
          sortable: false,
          class: "text-no-wrap",
          align: "end",
          only_lang: "ru"
        },
        {
          text: this.$t("viewSettings.goods_export.price_for_zzap"),
          value: "zzap_export_price",
          sortable: false,
          class: "text-no-wrap",
          align: "end",
          only_lang: "ru"
        },
        {
          text: this.$t("viewSettings.goods_export.price_for_ozon"),
          value: "ozon_export_price",
          sortable: false,
          class: "text-no-wrap",
          align: "end",
          only_lang: "ru"
        },
        {
          text: this.$t("viewGoods.amount_and_reserve"),
          value: "amount",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.min_amount"),
          value: "min_amount",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.storage"),
          value: "storage.name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.storage_rack"),
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.storage_rack_shelve"),
          sortable: false,
          class: "text-no-wrap",
        },
        { text: "", value: "actions" },
      ];
    },
  },
};
</script>

<style lang="css">
.small-padding-td-wrap td, .small-padding-td-wrap th{
  padding-left: 3px !important;
  pading-right: 3px !important;
}
</style>